<template>
<!-- 物资库-->
    <div class="declare-view">
        <div class="table-title">
            <Row type="flex">
                <div class="first-div">
                    <span class="input-label">物资分类：</span>
                    <span class="Cascader">
                        <Cascader
                            :data="productClassifyData"
                            v-model="productClassify"
                            @on-change="productClassifyChange"></Cascader>
                    </span>
                </div>
                <div class="boxs-div">
                    <span class="input-label">状态：</span>
                    <span class="Cascader">
                        <Select v-model="search.state" style="width:100px;">
                            <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                        </Select>
                    </span>
                </div>
                <div class="boxs-div">
                    <span class="input-label">物资名称：</span>
                    <span class="Cascader">
                        <Input placeholder="请输入物资名称"
                            v-model="productByClassifyVar.productName"/>
                    </span>
                </div>
                <div class="boxs-div">
                    <span class="input-label">p码：</span>
                    <span class="Cascader">
                        <Input placeholder="请输入物资编码"
                            v-model="productByClassifyVar.productNo"/>
                    </span>
                    <Button
                        class="boxs-div"
                        type="primary"
                        @click="handleSearch">
                        搜索
                    </Button>
                    <Button
                        class="boxs-div"
                        @click="handleReset">
                        重置
                    </Button>
                </div>
            </Row>
            <Row type="flex" style="margin-top: 6px">
                <div>
                    <Button @click="handelClick(3, {}, '2')">批量启用</Button>
                </div>
                <div class="boxs-div">
                    <Button @click="handelClick(4, {}, '1')">批量停用</Button>
                </div>
            </Row>
        </div>
        <div style="margin-top: 14px">
            <Table
                :columns="columns"
                :data="list"
                @on-selection-change="getSelectionChange"
                :height="500"
                ref="list">
                <template slot-scope="{ row }" slot="action">
                    <Button size="small" type="primary" v-if="row.state === 2" @click="handelClick(1, row)">启用</Button>
                    <Button size="small" v-if="row.state === 1" @click="handelClick(2, row)">停用</Button>
                    <!-- <Button size="small" type="primary"  v-if="row.state === 1" @click="handelClick(5, row)">同步</Button> -->
                </template>
            </Table>
            <div class="pages-footer">
                <Page
                    :current="productByClassifyVar.pageNumber"
                    :total="listTotal"
                    show-sizer
                    :page-size="productByClassifyVar.pageSize"
                    @on-page-size-change="getChangePageSize"
                    @on-change="getChangePageNum"/>
            </div>
        </div>
        <Modal
            class="model-postion-setting"
            v-model="tipModal"
            :title="tipModalTitle">
            <div class="history-order">
                <span>{{tipModalCon}}</span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="cancelModel">取消</span>
                <span class="his-ok" @click="submit" :loading="submitLoading">确定</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { queryProductClassify, queryAllProduct, disableProduct, enableProduct, syncProduct } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';

export default {
    data() {
        return {
            productClassify: [],
            productClassifyData: [],
            productName: '',
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 20,
                classifyNo: '',
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                productName: '',
                productNo: '',
                state: 0
            },
            search: {
                state: '0'
            },
            list: [],
            listTotal: 0,
            columns: [
                {
                    type: 'selection',
                    width: 50,
                    align: 'center'
                },
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 90
                },
                {
                    title: '分类名称',
                    key: 'classifyname',
                    minWidth: 120
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '物资单位',
                    key: 'productspec',
                    minWidth: 100
                },
                {
                    title: '状态',
                    key: 'state',
                    render(h, data) {
                        const items = [];
                        if (data.row.state === 1) {
                            items.push(h('span', {
                                class: ['success-color']
                            }, '已启用'));
                        } else if (data.row.state === 2) {
                            items.push(h('span', {
                                class: ['']
                            }, '未启用'));
                        }
                        return h('span', items);
                    },
                    minWidth: 80
                },
                {
                    title: '操作',
                    slot: 'action',
                    minWidth: 100
                }
            ],
            pageInfo: {
                classify: []
            },
            product: {},
            tipModal: false,
            tipModalTitle: '',
            tipModalCon: '',
            statusList: [
                {
                    value: '0',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '已启用'
                }
            ],
            selection: [],
            submitLoading: false,
            type: 0,
            rowInfo: {},
            pids: []
        };
    },
    mounted() {
        this.getProductClassify();
        this.getProductByClassifyNo();
    },
    methods: {
        submit() {
            this.submitLoading = true;
            if (this.type === 1 || this.type === 3) {
                this.$apollo.mutate({
                    mutation: enableProduct,
                    context: { useApi1: false },
                    variables: {
                        products: this.pids,
                        cliqueNo: Cookies.getJSON('cliqueNo').toString()
                    }
                }).then(res => {
                    this.submitLoading = false;
                    const data = res.data.enableProduct;
                    if (data && data.code === 200) {
                        this.$setNotice('启用成功');
                        this.tipModal = false;
                        this.getProductByClassifyNo();
                    } else {
                        this.$Message.error(data.message);
                    }
                });
            } else if (this.type === 2 || this.type === 4) {
                this.$apollo.mutate({
                    mutation: disableProduct,
                    context: { useApi1: false },
                    variables: {
                        products: this.pids,
                        cliqueNo: Cookies.getJSON('cliqueNo').toString()
                    }
                }).then(res => {
                    this.submitLoading = false;
                    const data = res.data.disableProduct;
                    if (data && data.code === 200) {
                        this.$setNotice('停用成功');
                        this.tipModal = false;
                        this.getProductByClassifyNo();
                    } else {
                        this.$Message.error(data.message);
                    }
                });
            } else if (this.type === 5) {
                this.$apollo.mutate({
                    mutation: syncProduct,
                    context: { useApi1: false },
                    variables: {
                        productNo: this.rowInfo.productno
                    }
                }).then(res => {
                    const data = res.data.syncProduct;
                    if (data && data.code === 200) {
                        this.$setNotice('同步成功');
                        this.tipModal = false;
                    } else {
                        this.$Message.error(data.message);
                    }
                });
            }
        },
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },
        // 获取物资列表
        getProductByClassifyNo() {
            this.productByClassifyVar.state = Number(this.search.state);
            this.$apollo.query({
                query: queryAllProduct,
                context: { useApi1: false },
                variables: this.productByClassifyVar,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryAllProduct;
                if (data && data.data && data.code === 200) {
                    this.listTotal = data.count;
                    data.data.forEach(item => {
                        item._disabled = false;
                        item._checked = false;
                    });
                    this.list = data.data;
                }
            });
        },
        handleSearch() {
            this.productByClassifyVar.pageNumber = 1;
            this.getProductByClassifyNo();
        },
        handleReset() {
            this.productByClassifyVar.pageNumber = 1;
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = '';
            this.productByClassifyVar.productNo = '';
            this.search.state = '0';
            this.productClassify = [];
            this.getProductByClassifyNo();
        },
        // 选中物资分类
        productClassifyChange(val) {
            this.pageInfo.classify = val;
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.productNo = '';
            this.productByClassifyVar.classifyNo = val[val.length - 1] || '';
        },
        getChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
            this.getProductByClassifyNo();
        },
        // pagesize 变化
        getChangePageSize(size) {
            this.productByClassifyVar.pageSize = size;
            this.getProductByClassifyNo();
        },
        getSelectionChange(selection) {
            this.selection = selection;
        },
        cancelModel() {
            for (let i = 0;i < this.list.length;i++) {
                this.$set(this.list[i], '_disabled', false);
                this.$set(this.list[i], '_checked', false);
            }
            this.tipModal = false;
        },
        handelClick(type, row, status) {
            this.type = type;
            this.rowInfo = row;
            this.pids = [];
            if (type === 3 || type === 4) {
                if (this.selection.length) {
                    for (let i = 0;i < this.list.length;i++) {
                        for (let j = 0;j < this.selection.length;j++) {
                            if (this.list[i].id === this.selection[j].id) {
                                if (this.selection[j].state !== Number(status)) {
                                    this.$set(this.list[i], '_disabled', true);
                                } else {
                                    this.$set(this.list[i], '_checked', true);
                                }
                            }
                        }
                    }
                    this.selection.forEach(item => {
                        if (item.state === Number(status)) {
                            this.pids.push({
                                productNo: item.productno,
                                classifyNo: item.classifyno
                            });
                        }
                    });
                }
            } else {
                this.pids.push({
                    productNo: row.productno,
                    classifyNo: row.classifyno
                });
            }
            switch (type) {
                case 1:
                    this.tipModalTitle = '启用';
                    this.tipModalCon = `确定启用物资${row.productname}?`;
                    this.tipModal = true;
                    break;
                case 2:
                    this.tipModalTitle = '停用';
                    this.tipModalCon = `确定停用物资${row.productname}?`;
                    this.tipModal = true;
                    break;
                case 3:
                    if (this.pids.length) {
                        this.tipModalTitle = '批量启用';
                        this.tipModalCon = `确定启用这${this.pids.length}个物资?`;
                        this.tipModal = true;
                    } else {
                        this.$setNotice('请选择物资');
                        for (let i = 0;i < this.list.length;i++) {
                            this.$set(this.list[i], '_disabled', false);
                            this.$set(this.list[i], '_checked', false);
                        }
                    }
                    break;
                case 4:
                    if (this.pids.length) {
                        this.tipModalTitle = '批量停用';
                        this.tipModalCon = `确定停用这${this.pids.length}个物资?`;
                        this.tipModal = true;
                    } else {
                        this.$setNotice('请选择物资');
                        for (let i = 0;i < this.list.length;i++) {
                            this.$set(this.list[i], '_disabled', false);
                            this.$set(this.list[i], '_checked', false);
                        }
                    }
                    break;
                case 5:
                    this.tipModalTitle = '同步';
                    this.tipModalCon = `确定同步物资${row.productname}?`;
                    this.tipModal = true;
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.boxs-div
    margin-left: 16px;
.first-div
    margin-bottom: 12px;
</style>



// WEBPACK FOOTER //
// src/views/materialsIndepend/index.vue